import { Box, Typography } from '@mui/material';
import { Info, type LucideIcon } from 'lucide-react';
import type { ReactElement, ReactNode } from 'react';

import { Icon } from '@/ui/kit';

/**
 * Encart d'information permanent : une phrase qui doit rester lisible, jamais une
 * alerte. Ecrit ici et non au kit : cet ecran est le seul a s'en servir — la
 * regle d'entree du kit demande deux ecrans.
 *
 * Le texte porte le sens ; le fond et l'icone n'y ajoutent qu'un reperage.
 */
export const InfoNote = ({
  title,
  children,
  icon = Info,
}: {
  readonly title?: string;
  readonly children: ReactNode;
  readonly icon?: LucideIcon;
}): ReactElement => (
  <Box
    component="aside"
    aria-label={title}
    sx={{
      display: 'flex',
      gap: 1.5,
      alignItems: 'flex-start',
      px: 2,
      py: 1.5,
      borderRadius: '12px',
      border: 1,
      borderColor: 'tokens.border',
      bgcolor: 'tokens.infoSoft',
      color: 'tokens.infoText',
    }}
  >
    <Box sx={{ display: 'inline-flex', mt: '2px', flexShrink: 0 }}>
      <Icon icon={icon} size={18} />
    </Box>
    <Box sx={{ minWidth: 0 }}>
      {title === undefined ? null : (
        <Typography component="p" sx={{ fontSize: 14, fontWeight: 700, lineHeight: '20px' }}>
          {title}
        </Typography>
      )}
      <Typography component="div" sx={{ fontSize: 14, lineHeight: '20px' }}>
        {children}
      </Typography>
    </Box>
  </Box>
);
